import PropTypes, {InferProps} from "prop-types";
import {usePrincipal, useProject, useSessionProject} from "@betrue/front/services";
import {ProjectFormView} from "./project-form.view";
import {ProjectFormForm} from "./project-form.form";
import {useCallback, useEffect, useState} from "react";


export const ProjectFormPropsTypes = {
  nextStep: PropTypes.string,
  projectNameLabel: PropTypes.string,
  dueDateLabel: PropTypes.string,
  projectDescriptionLabel: PropTypes.string,
  projectSubmitLabel: PropTypes.string,
}
export type ProjectFormProps = InferProps<typeof ProjectFormPropsTypes>

export const ProjectForm = (props: ProjectFormProps) => {
  const [currentProject, , {createProject, updateProject, getProjectById}] = useProject()
  const [submitted, setSubmitted] = useState(false)
  const [sessionProject, setSessionProject] = useSessionProject()

  const [principal] = usePrincipal()

  const handleCreateProject = useCallback(async (form: ProjectFormForm) => {
    if (currentProject.id) {
      await createProject({...currentProject, ...form})
    } else {
      await createProject({...sessionProject, ...form})
    }
    setSubmitted(true)
  }, [currentProject])

  useEffect(() => {
    if (submitted) {
      if (props.nextStep) {
        window.location.href = `${props.nextStep}/?projectId=${currentProject.id}`
      } else {
        setSubmitted(false)
      }

    }
  }, [currentProject])

  if (!principal || !currentProject) return (<>...</>)
  return (
    <ProjectFormView {...props} currentUser={principal} onCreateProject={handleCreateProject}
                     project={currentProject?.id ? currentProject : sessionProject}/>
  );
}

ProjectForm.propTypes = ProjectFormPropsTypes
